
        <mat-table [dataSource]="groupDistributionDataSource">
            <ng-container matColumnDef="select">
                <th *matHeaderCellDef mat-header-cell>
                    <mat-checkbox 
                           (change)="selectAllChanged($event)"
                           [checked]="selectAll"
                           [indeterminate]="isIndeterminate()"
                           class="checkboxHeight"
                           id="selectAllCheckbox">
                    </mat-checkbox>
                </th>
                <td *matCellDef="let customer" mat-cell>
                    <mat-checkbox class="example-margin"
                                [(ngModel)]="customer.checked" 
                                (ngModelChange)="customerSelected(customer);">
                    </mat-checkbox>
                </td>
            </ng-container>

            <ng-container matColumnDef="customer">
                <th *matHeaderCellDef mat-header-cell>
                    <mat-form-field appearance="outline">
                        <mat-label>Customer Filter</mat-label>
                        <input 
                            placeholder="search customer"
                           class="e-input"
                           id="searchBox" (input)="applyFilter($event.currentTarget.value)"
                           matInput>
                    </mat-form-field>
                </th>
                <td *matCellDef="let customer" mat-cell (click)="customerSelectedRow(customer);">
                    <div style="width:250px">{{customer.company}}</div>
                </td>
            </ng-container>

            <tr *matHeaderRowDef="getTableColumns(); sticky: true" mat-header-row></tr>
            <tr *matRowDef="let row; columns: getTableColumns()" mat-row></tr>
        </mat-table>
